/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPaginatedBusinessAngelDividendListDto } from '../../models/backend-paginated-business-angel-dividend-list-dto';

export interface VentureFundsBusinessAngelDividendsList$Params {
  /**
   * Number of results to return per page.
   */
  limit?: number;

  /**
   * The initial index from which to return the results.
   */
  offset?: number;
}

export function ventureFundsBusinessAngelDividendsList(
  http: HttpClient,
  rootUrl: string,
  params?: VentureFundsBusinessAngelDividendsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPaginatedBusinessAngelDividendListDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsBusinessAngelDividendsList.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPaginatedBusinessAngelDividendListDto>;
    }),
  );
}

ventureFundsBusinessAngelDividendsList.PATH = '/api/venture_funds/business-angel-dividends/';
